module.exports = __webpack_public_path__ + "static/aso4-68adc6c2aeccedfcc926cd9ff46d2aaf.png";